export default "__VITE_ASSET__nMD0ggKv__"